import $ from "jquery";
import Ajax from "base/Ajax";

export default class ProductComparisonTable {
    constructor($element) {
        this.$element = $element;
        this.$filters = this.$element.find('.js-filter');
        this.$table = this.$element.find('.js-comparison-table');
        this.$matrix_table = this.$table.find('.matrix-table');

        this.element = this.$matrix_table[0];

        this.filters = {};
        this.request = null;

        this.pos = {top: 0, left: 0, x: 0, y: 0};

        this.mouseMoveHandler = this.mouseMoveHandler.bind(this);
        this.mouseUpHandler = this.mouseUpHandler.bind(this);

        this.checkForMaxScroll = this.checkForMaxScroll.bind(this);
        this.checkForNoScroll = this.checkForNoScroll.bind(this);

        this.bindEvents();

        this.updateLatestFilters();
        this.updateFilters();

        this.checkForMaxScroll();
        this.checkForNoScroll();
    }

    bindEvents() {
        let me = this;

        this.$element.on('click', '.js-apply-changes', () => {
            this.updateLatestFilters();
            this.updateTable(true);
            this.closeFilter();
            return false;
        }).on('click', '.js-close-filter', () => {
            this.closeFilter();
            return false;
        }).on('click', '.js-clear-filters', () => {
            this.clearFilters();
            this.updateTable(true);
            this.closeFilter();
            return false;
        }).on('mousedown', 'th:not(:first-child), td:not(".matrix-table__row-heading")', function (e) {
            me.mouseDownHandler(e);
            return;
        });

        this.$matrix_table.on('scroll', () => {
            this.checkForMaxScroll();
        });

        $(window).on('resize', function () {
            me.checkForMaxScroll();
            me.checkForNoScroll();
        });
    }

    checkForMaxScroll() {
        if (this.element.scrollWidth - this.element.scrollLeft - this.element.clientWidth - 5 > 0) {
            this.$table.removeClass('matrix-table-container--end');
        } else {
            this.$table.addClass('matrix-table-container--end');
        }
    }

    checkForNoScroll() {
        if (this.element.scrollWidth <= this.element.clientWidth) {
            this.$table.addClass('matrix-table-container--no-scroll');
        } else {
            this.$table.removeClass('matrix-table-container--no-scroll');
        }
    }

    mouseDownHandler(e) {
        this.pos = {
            // The current scroll
            left: this.element.scrollLeft,
            top: this.element.scrollTop,
            // Get the current mouse position
            x: e.clientX,
            y: e.clientY,
        };

        this.$matrix_table.addClass('matrix-table--moving');

        document.addEventListener('mousemove', this.mouseMoveHandler);
        document.addEventListener('mouseup', this.mouseUpHandler);
    }

    mouseMoveHandler(e) {
        // How far the mouse has been moved
        const dx = e.clientX - this.pos.x;
        const dy = e.clientY - this.pos.y;

        // Scroll the element
        this.element.scrollTop = this.pos.top - dy;
        this.element.scrollLeft = this.pos.left - dx;
    }

    mouseUpHandler(e) {
        document.removeEventListener('mousemove', this.mouseMoveHandler);
        document.removeEventListener('mouseup', this.mouseUpHandler);

        this.$matrix_table.removeClass('matrix-table--moving');
    }

    closeFilter() {
        $('body').removeClass('show-filter');
    }

    updateLatestFilters() {
        this.filters = this.$filters.serializeJSON();
    }

    updateFilters() {
        Object.keys(this.filters).forEach((key) => {
            if ('undefined' !== typeof key) {
                let value = this.filters[key];
                if (Array.isArray(value)) {
                    value.forEach((filter) => {
                        this.$filters.find('input[type="checkbox"][name="' + key + '[]"][value="' + filter + '"]').prop('checked', true);
                    });
                } else {
                    this.$filters.find('input[type="checkbox"][name="' + key + '"][value="' + value + '"]').prop('checked', true);
                }
                total++;
            }
        });

        let total = this.$filters.find('input[type="checkbox"]:checked').length;
        this.$element.find('.js-filter-amount').text(total);

        if (total > 0) {
            this.$filters.find('.js-clear-filters').show();
        } else {
            this.$filters.find('.js-clear-filters').hide();
        }
    }

    clearFilters() {
        this.$filters.find('input[type="checkbox"]').prop('checked', false);
        this.filters = {};
    }

    updateTable(pushState) {
        this.$table.addClass('loading');

        if (this.request !== null) {
            this.request.abort();
        }

        this.request = Ajax.get('avery-berkel/v1', 'comparison-table', this.filters);
        this.updateFilters();

        this.request.then((data) => {
            this.request = null;

            if ('undefined' !== typeof data.table) {
                this.$matrix_table.off('scroll', this.checkForMaxScroll);

                this.$table.html(data.table);
                this.$matrix_table = this.$table.find('.matrix-table');
                this.element = this.$matrix_table[0];

                setTimeout(() => {
                    this.checkForMaxScroll();
                    this.checkForNoScroll();

                    this.$matrix_table.on('scroll', () => {
                        this.checkForMaxScroll();
                    });
                });
            }

            this.$table.removeClass('loading');
        }).catch((e) => {
            this.request = null;
            this.$table.removeClass('loading');
        });

        if (pushState) {
            history.pushState({}, '', this.fullPageUrl());
        }
    }

    fullPageUrl() {
        let base = window.location.origin + window.location.pathname;

        let queryString = this.pageQueryString(base);

        return base + queryString;
    }

    pageQueryString(base) {
        let queryString = '';
        let filters = Object.assign({}, this.filters);

        delete filters.post_id;

        if (Object.keys(filters).length > 0) {
            queryString += "?" + $.param(filters).replace(/%5B%5D/g, "[]");
        }

        return queryString;
    }
}

ProductComparisonTable.SIDEBAR_SIZE = 960;